import React from 'react';
import { Avatar, Box, Grid, Typography } from '@material-ui/core';
import { PersonOutline } from '@material-ui/icons';
import { useIntl } from 'react-intl';
import { OnboardingDraftSelect, OnboardingDraftText, useOnboardingDraft } from './OnboardingDraft';
import { useStyles } from './Onboarding.styles';

export const OnboardingAdmin = () => {
  const { draft, update, languages } = useOnboardingDraft();
  const { formatMessage: t } = useIntl();
  const classes = useStyles();
  return <Box className={classes.adminStepContentInner}>
    <Box className={classes.adminDetailsHeading}>
      <Avatar className={classes.adminDetailsIcon}><PersonOutline /></Avatar>
      <Typography variant="h6">{t({ id: 'onboarding.step.permissions' })}</Typography>
    </Box>
    <Grid container spacing={2} className={classes.adminFields}>
      {(['firstName', 'lastName', 'email'] as const).map(field => <Grid item xs={12} sm={6} key={field}>
        <OnboardingDraftText label={t({ id: `form.${field}` })} type={field === 'email' ? 'email' : 'text'} value={draft.admin[field]} onChange={value => update(current => ({ ...current, admin: { ...current.admin, [field]: value } }))} />
      </Grid>)}
      <Grid item xs={12} sm={6}><OnboardingDraftSelect name="admin-language" label={t({ id: 'form.selectLanguage' })} ids={[draft.admin.language]} options={languages} multi={false} required onChange={ids => update(current => ({ ...current, admin: { ...current.admin, language: ids[0] || 0 } }))} /></Grid>
    </Grid>
  </Box>;
};
